<template>
  <main>
    <b-button class="mt-2" size="sm" variant="danger" @click.prevent="exportPDF()">
      Export PDF for your Records
    </b-button>
    <vue-html2pdf
      id="printpdf"
      ref="html2Pdf"
      :filename="getPdfFileName()"
      :manual-pagination="true"
      :paginate-elements-by-height="500"
      :pdf-quality="2"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      pdf-content-width="100%"
      pdf-format="a4"
      pdf-orientation="portrait"
      @hasDownloaded="hasDownloaded($event)"
      @beforeDownload="beforeDownload($event)"
    >
      <section slot="pdf-content">
        <div class="text-center my-3">
          <b-img :src="pfizerLogo"></b-img>
        </div>
        <h4 class="text-center mb-2 mt-4">
          <div>{{ eventName }}</div>
          <div>Digital Version 1.0</div>
        </h4>
        <section class="text-center mb-5">
          Protocol ID: <strong>{{ studyId }}</strong> <br />
          Site ID: <strong>{{ siteId }}</strong
          ><br />
          Investigator Name: <strong>{{ investigatorName }}</strong
          ><br />
          Form Completed by: <strong>{{ userEmail }}</strong>
          <p>
            Form Completed Date: <strong>{{ dateTime }} (GMT)</strong>
          </p>
          <p>
            Document ID: <strong>{{ eventId }}</strong>
          </p>
        </section>
        <div v-for="(item, index) in data" :key="item['Id']" class="px-3">
          <section v-if="item['type'] === 'StaticList'">
            <div class="html2pdf__page-break" />
            <div id="test"></div>
            <div class="my-3 font-weight-bold">{{ item['question'] }}</div>
            <b-table
              :items="item['value']"
              :fields="item['labels']"
              bordered
              fixed
              head-variant="light"
              hover
              small
            >
            </b-table>
          </section>
          <section v-else-if="item['type'] !== 'SubSection'">
            <strong>{{ item['question'] }}</strong>
            <p>&nbsp;{{ item['value'] }}</p>
          </section>
          <section v-else>
            <div class="html2pdf__page-break" />
            <sub-section
              :helpText="item['helpText']"
              :label="item['question']"
              :name="item['question']"
              :questionId="item['Id']"
              class="mt-3"
            ></sub-section>
          </section>
        </div>
        <div class="text-center mt-4" style="background-color: whitesmoke; padding: 10px;">
          <div v-if="displayRowOfFooter">Site Equivalent Excursion Form</div>
          Pfizer Confidential<br />
          Effective 21-Nov-2022
        </div>
      </section>
    </vue-html2pdf>
  </main>
</template>

<script>
  import pfizerLogo from '../../../images/pfizer_new_logo.png';
  import { mapGetters } from 'vuex';
  import VueHtml2pdf from 'vue-html2pdf';
  import SubSection from './question-model/SubSection.vue';
  import moment from 'moment';

  export default {
    props: {
      questions: Array,
      eventName: String,
      investigatorName: String,
      siteId: String,
      studyId: String,
      childOfListQuestions: Object || Array,
      eventId: String,
    },
    props: [
      'questions',
      'eventName',
      'investigatorName',
      'siteId',
      'studyId',
      'childOfListQuestions',
      'eventId',
    ],
    components: {
      VueHtml2pdf,
      SubSection,
    },
    data() {
      return {
        pfizerLogo: pfizerLogo,
        documents: [],
        isOpen: false,
        data: [],
        footer: '',
        userEmail: window['Laravel']['user_email'],
        sendEmail: false,
      };
    },
    created() {},
    computed: {
      ...mapGetters(['personQuestionFormData']),
      dateTime() {
        return moment()
          .utc()
          .format('D MMM YYYY HH:mm');
      },
      displayRowOfFooter() {
        let typeOfFomrs = ['Storage Excursion Form', 'Site Equivalent Storage Form'];
        return typeOfFomrs.includes(this.eventName);
      },
    },
    methods: {
      exportPDF(action, documents = []) {
        this.sendEmail = action === 'sendEmail';
        this.documents = documents;
        this.data.splice(0, this.data.length);

        this.questions.forEach(question => {
          if (question['Attribute_Type__c'] === 'StaticList') {
            let staticListChildren = _.cloneDeep(this.childOfListQuestions[question['Id']]);
            let staticListData = [];
            for (let index = 0; index < question['Number_of_Rows__c'] + 1; index++) {
              let row = [];
              for (let idx = 0; idx < staticListChildren.length; idx++) {
                row.push('');
              }
              staticListData.push(row);
            }

            for (let idx = 0; idx < staticListChildren.length; idx++) {
              staticListData[0][idx] = staticListChildren[idx]['Label__c']
                ? staticListChildren[idx]['Label__c'].replaceAll(/<\/?[^>]+(>|$)/gi, '')
                : '';
            }

            staticListChildren.forEach((item, idx) => {
              let foundKey = Object.keys(this.personQuestionFormData).find(el =>
                el.includes(item['Id']),
              );
              let value = foundKey ? this.personQuestionFormData[foundKey]['value'] : '';
              let ar = JSON.parse('[' + value + ']');
              for (let index = 1; index < question['Number_of_Rows__c'] + 1; index++) {
                staticListData[index][idx] = ar[0]?.[index - 1] ?? '';
              }
            });

            let staticListDataItemsLabels = staticListData[0];
            let staticListDataItems = staticListData.map((item, idx) => {
              let obj = {};
              if (idx !== 0) {
                staticListDataItemsLabels.forEach((label, index) => {
                  obj[label] = item[index];
                });
              }
              return obj;
            });

            let item = {
              'id:': question['Id'],
              question: question['Label__c'],
              value: staticListDataItems,
              labels: staticListDataItemsLabels,
              type: question['Attribute_Type__c'],
              helpText: question['Help_Text__c'],
            };
            this.data.push(item);
          } else {
            let foundKey = null;
            if (this.personQuestionFormData) {
              foundKey = Object.keys(this.personQuestionFormData).find(el =>
                el.includes(question['Id']),
              );
            }
            let item = {
              'id:': question['Id'],
              question: question['Label__c'],
              value: foundKey ? this.personQuestionFormData[foundKey]['value'] : '',
              type: question['Attribute_Type__c'],
              helpText: question['Help_Text__c'],
            };
            this.data.push(item);
          }
        });
        console.log('wwddwd');
        this.$refs.html2Pdf.generatePdf();
      },
      getPdfFileName() {
        let pdfName = this.eventName.replaceAll(' ', '_');
        return pdfName + '-' + this.eventId;
      },
      hasDownloaded(event) {
        if (this.sendEmail) {
          this.sendFileViaEmail(event);
        }
        this.$bvToast.toast('PDF generated successfully!', {
          title: 'PDF Generation',
          variant: 'success',
          solid: true,
        });
      },
      async beforeDownload({ html2pdf, options, pdfContent }) {
        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .get('pdf')
          .then(pdf => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);
              pdf.text(
                'Page ' + i + ' of ' + totalPages,
                pdf.internal.pageSize.getWidth() * 0.45,
                pdf.internal.pageSize.getHeight() - 0.2,
              );
            }
          })
          .save();
      },
      async sendFileViaEmail(pdf) {
        const formData = new FormData();
        const headers = { 'Content-Type': 'multipart/form-data' };
        formData.append('pdfFile', pdf, 'filename.pdf');
        formData.append('eventName', this.eventName);
        formData.append('studyId', this.studyId);
        formData.append('salesforceId', this.eventId);
        for (let i = 0; i < this.documents.length; i++) {
          formData.append('documents[]', this.documents[i]);
        }
        axios
          .post('/send-pdf-email', formData, { headers })
          .then(response => {
            this.$bvToast.toast('Email sent successfully!', {
              title: 'Email sending',
              variant: 'success',
              solid: true,
            });
          })
          .catch(error => {
            console.error(error);
            this.$bvToast.toast('Something went wrong.The email was not sent!', {
              title: 'Emai sending',
              variant: 'danger',
              solid: true,
            });
          });
      },
    },
  };
</script>
